module.exports = __webpack_public_path__ + "img/insurance.823015bf.png";